import SimpleCard from "lib/components/common/simple-card";
import SimpleDataTable from "lib/components/common/simple-data-table";
import DashboardLayout from "lib/components/layouts/dashboard";
import { PAGE_ROUTES } from "lib/constants/page-routes";
import {
  PATIENTS_COLUMNS
} from "lib/constants/table-columns";
import { useContext, useEffect, useMemo, useState } from "react";
import { AppContext } from "lib/contexts/app-context";
import { useNavigate } from "react-router-dom";
import usePatients from "lib/hooks/usePatients";
import { Button, FormControl } from "react-bootstrap";


const breadcrumbItems = [
  {
    label: "Dashboard",
    path: PAGE_ROUTES.ADMIN.Dashboard,
  },
  {
    label: "Patients Management",
    path: PAGE_ROUTES.ADMIN.PatientsManagement,
  },
] as BreadcrumbItem[];

const AdminPatientsManagementPage = () => {
  const navigateTo = useNavigate();
  const { appState } = useContext(AppContext);
  const [searchText, setSearchText] = useState("");

  const {
    patients,
    getAllPatients,
    loading: patientsLoading,
    error: patientsError,
  } = usePatients();

  const [selectedPatientId, setSelectedPatientId] = useState<string | null>(null);

  useEffect(() => {
    getAllPatients();
  }, []);

  const handlePatientSelection = (patient?: Patient) => {
    if (patient) {
      setSelectedPatientId(patient.id);
      navigateTo(PAGE_ROUTES.ADMIN.PatientProfile, { state: { patientId: patient.id, patientName: patient.name} });
    } else {
      setSelectedPatientId(null);
    }
  };

  /** Filter patients */
  const filteredPatients = useMemo(() => {
    if (!searchText) return patients;
    return patients.filter(
      (p) =>
        p.name?.toLowerCase().includes(searchText.toLowerCase()) 
        // ||
        // p.email?.toLowerCase().includes(searchText.toLowerCase()) ||
        // p.phone?.toLowerCase().includes(searchText.toLowerCase())
    );
  }, [patients, searchText]);

  /** Calculated Vars */

  return (
    <DashboardLayout breadcrumbItems={breadcrumbItems}>
      <SimpleCard
        title="Patients Management"
        isLoading={patientsLoading}
        error={patientsError}
        action={<Button onClick={() => navigateTo(PAGE_ROUTES.ADMIN.AddPatient)}>Add Patient</Button>}
      >
        {/* Search Input */}
        <div className="mb-3" style={{ minWidth: "350px", float: "right" }}>
          <FormControl
            type="text"
            placeholder="Search patients..."
            value={searchText}
            onChange={(e) => setSearchText(e.target.value)}
          />
        </div>

        <SimpleDataTable
          title=""
          columns={PATIENTS_COLUMNS}
          data={filteredPatients}
          isLoading={patientsLoading}
          error={patientsError}
          defaultSortFieldId="date"
          defaultSortAsc={false}
          className="mt-3"
          onRowClick={(row) => handlePatientSelection(row as Patient)}
        />
      </SimpleCard>
    </DashboardLayout>
  );
};

export default AdminPatientsManagementPage;
